import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
};

const defaultProps = {};

function ErrorFallback({ error }) {
    return (
        <div role="alert">
            <div role="alert">
                <p>Something went wrong:</p>
                <pre>{error.message}</pre>
            </div>
        </div>
    );
}

ErrorFallback.propTypes = propTypes;
ErrorFallback.defaultProps = defaultProps;

export default ErrorFallback;
